import Validate from '../components/Validate/Validate';
import IntegrtiasLogo from '../assets/logos/IntegritasLogo.svg';
import GradientBackground from '../components/GradientBackground/GradientBackground';
const Home = () => {
  // FIXME n remove animation on validatestate   ${!disableAnimation && !validateState && 'animate-slide-in-up'}
  return (
    // Header 100px + margin 60px *2 = 220px
    <main className="relative m-[20px] p-[8px] md:m-[60px] md:p-[112px] flex items-center justify-between overflow-hidden">
      {/* Background inside main but behind content */}
      <GradientBackground />

      {/* Foreground Content - Ensure it is above the background */}
      <div
        className="relative z-10 flex items-center justify-center w-full 
      gap-5 flex-col lg:flex-row lg:gap-20"
      >
        <Validate />
        <section className="flex flex-col justify-center  text-white h-[540px] w-[415px]">
          <img src={IntegrtiasLogo} className="animate-slide-up-main h-[70px] w-[270px]" />
          <div className="animate-slide-up-main pt-[40px]">
            <p className="text-2xl font-normal mb-4">
              Generate a report from on-chain data records by analyzing your data here.
            </p>
            <div className="text-sm sm:text-base font-normal space-y-3">
              <p>
                <strong>How to verify data:</strong>
              </p>
              <ol className="space-y-2">
                <li className="grid grid-cols-[auto_1fr] gap-3">
                  <span className="text-white w-4">1.</span>
                  <span className="self-end">
                    Get your proof file from <strong>History → Stamps</strong>
                  </span>
                </li>
                <li className="grid grid-cols-[auto_1fr] gap-3">
                  <span className="text-white w-4">2.</span>
                  <span className="self-end">Upload the proof file</span>
                </li>
                <li className="grid grid-cols-[auto_1fr] gap-3">
                  <span className="text-white w-4">3.</span>
                  <span className="self-end">
                    Go to <strong>History → Verifications</strong> to see your verification report
                  </span>
                </li>
              </ol>
              <p className="mt-4 text-xs sm:text-xs">
                By submitting your data, you confirm that you have obtained consent from the data
                owner or have the lawful authority to do so. Additionally, you agree that Minima may
                use this data for analytics, tool enhancement, and research purposes.
              </p>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Home;
